import label from "@/lang/StaticLabels.js";

// PMRPALAL Navbar  - برنامه ریزی تولید آلومینیوم -----------------------------------------------
let navItems = [
  {
    title: label.modules.pmrpAl,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PMRPALDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PMRPALWorkStation",
        label: label.menu.workStations,
        metaLabel: label.page.workStations,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALWorkShift",
        label: label.menu.workShifts,
        metaLabel: label.page.workShifts,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALSprint",
        label: label.menu.sprint,
        metaLabel: label.page.sprint,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALBOMList",
        label: label.menu.bom,
        metaLabel: label.page.bom,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALProcessType",
        label: label.menu.processType,
        metaLabel: label.page.processType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALHardness",
        label: label.menu.hardness,
        metaLabel: label.page.hardness,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALProductSurface",
        label: label.menu.productSurface,
        metaLabel: label.page.productSurface,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALUsageGroup",
        label: label.menu.usageGroup,
        metaLabel: label.page.usageGroup,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALFoilUsage",
        label: label.menu.foilUsage,
        metaLabel: label.page.foilUsage,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALInnerCoreDiameter",
        label: label.menu.innerCoreDiameter,
        metaLabel: label.page.innerCoreDiameter,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALFurnace",
        label: label.menu.furnace,
        metaLabel: label.page.furnace,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PMRPALSystemSetting",
        label: label.menu.settings,
        metaLabel: label.page.settings,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: null,
        label: label.menu.order,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PMRPALAddOrder",
            label: label.menu.addOrder,
            metaLabel: label.page.addOrder,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPALOrderList",
            label: label.menu.orderList,
            metaLabel: label.page.order,
            icon: "mdi-circle-small",
          },
        ],
      },
      {
        to: null,
        label: label.menu.produce,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PMRPALAddProduceOrder",
            label: label.menu.addProduceOrder,
            metaLabel: label.page.addProduceOrder,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPALProduceOrderList",
            label: label.menu.produceOrder,
            metaLabel: label.page.produceOrder,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPALCasting",
            label: label.menu.casting,
            icon: "mdi-subdirectory-arrow-left",
            active: false,
            subItems: [
              {
                to: "PMRPALCastingCartable",
                label: label.menu.produceOrdeConfirm,
                metaLabel: label.page.castingCartable,
                icon: "mdi-chevron-left",
              },
              { 
                to: "PMRPALCastingList",
                label: label.menu.produceOrder,
                metaLabel: label.page.casting,
                icon: "mdi-chevron-left",
              },
              {
                to: "PMRPALCastingReportList",
                label: label.menu.productionOrderReport,
                metaLabel: label.page.castingReport,
                icon: "mdi-chevron-left",
              },
              {
                to: "PMRPALCastingQC",
                label: label.menu.qc,
                metaLabel: label.page.castingQC,
                icon: "mdi-chevron-left",
              },
            ],
          },
          {
            to: "PMRPALColdRolling",
            label: label.menu.coldRolling,
            icon: "mdi-subdirectory-arrow-left",
            active: false,
            subItems: [
              {
                to: "PMRPALColdRollingCartable",
                label: label.menu.produceOrdeConfirm,
                metaLabel: label.page.coldRollingtCartable,
                icon: "mdi-chevron-left",
              },
              {
                to: "PMRPALColdRollingList",
                label: label.menu.produceOrder,
                metaLabel: label.page.coldRolling,
                icon: "mdi-chevron-left",
              },
              {
                to: "PMRPALColdRollingReportList",
                label: label.menu.productionOrderReport,
                metaLabel: label.page.coldRollingReport,
                icon: "mdi-chevron-left",
              },
              {
                to: "PMRPALColdRollingQC",
                label: label.menu.qc,
                metaLabel: label.page.coldRollingQC,
                icon: "mdi-chevron-left",
              },
            ],
          },
          {
            to: "PMRPALColdRolling",
            label: label.menu.foilRolling,
            icon: "mdi-subdirectory-arrow-left",
            active: false,
            subItems: [
              {
                to: "PMRPALFoilRollingCartable",
                label: label.menu.produceOrdeConfirm,
                metaLabel: label.page.foilRollingCartable,
                icon: "mdi-chevron-left",
              },
              {
                to: "PMRPALFoilRollingList",
                label: label.menu.produceOrder,
                metaLabel: label.page.foilRolling,
                icon: "mdi-chevron-left",
              },
              {
                to: "PMRPALFoilRollingReportList",
                label: label.menu.productionOrderReport,
                metaLabel: label.page.foilRollingReport,
                icon: "mdi-chevron-left",
              },
              {
                to: "PMRPALFoilRollingQC",
                label: label.menu.qc,
                metaLabel: label.page.foilRollingQC,
                icon: "mdi-chevron-left",
              },
            ],
          },
        ],
      },
      {
        to: null,
        label: label.menu.managementCartable,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [
          {
            to: "PMRPALCastingManagementCartable",
            label: label.menu.casting,
            metaLabel: label.page.castingManagementCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPALColdRollingManagementCartable",
            label: label.menu.coldRolling,
            metaLabel: label.page.coldRollingManagementCartable,
            icon: "mdi-circle-small",
          },
          {
            to: "PMRPALFoilRollingManagementCartable",
            label: label.menu.foilRolling,
            metaLabel: label.page.foilRollingManagementCartable,
            icon: "mdi-circle-small",
          },
        ],
      },
    ],
  },
  {
    to: null,
    label: label.menu.reports,
    icon: "mdi-chart-bar-stacked",
    active: false,
    subItems: [
      {
        to: "PMRPALproductionReports",
        label: label.menu.productionReports,
        metaLabel: label.page.productionReports,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
